export default __webpack_public_path__ + "static/media/bkg--team-1.b28e2492.jpg";